import { CustomFieldField, CustomFieldValueAttributes } from '@/types'
import { CustomFieldValueOptionsQuery } from './__generated__/options_query'
import { ErrorMessage, Field, Label } from '@/components/base/fieldset'
import { Switch } from '@/components/base/switch'
import { Input } from '@/components/base/input'
import { Selector as CustomFieldOptionSelector } from '@/components/custom_field_option/selector'

interface Props {
  customFields: CustomFieldValueOptionsQuery['customFields']
  attributes: CustomFieldValueAttributes
  setAttributes: React.Dispatch<React.SetStateAction<CustomFieldValueAttributes>>
  fieldErrors: Record<keyof CustomFieldValueAttributes, string> | undefined
}

export const valueField = ({ customFields, attributes, setAttributes, fieldErrors }: Props) => {
  if (!customFields) return <></>

  const customField = customFields.nodes.find(cf => cf.id === attributes.customFieldId)
  let field = <></>

  switch (customField?.fieldType) {
    case CustomFieldField.Boolean:
      field = (
        <Switch
          checked={attributes.value == 'true'}
          className="ml-4 self-center"
          onChange={value => setAttributes({ ...attributes, value: value ? 'true' : 'false' })}
        />
      )
      break
    case CustomFieldField.Text:
      field = (
        <Input
          invalid={!!fieldErrors?.value}
          type="text"
          value={attributes.value || ''}
          onChange={e => setAttributes({ ...attributes, value: e.target.value }) }
        />
      )
      break
    case CustomFieldField.Select:
      field = (
        <CustomFieldOptionSelector
          invalid={!!fieldErrors?.value}
          options={customField.options || []}
          value={attributes.value || ''}
          onChange={value => setAttributes({ ...attributes, value: value?.id }) }
        />
      )
      break
    default: return <></>
  }

  return (
    <Field>
      <Label>Value</Label>
      { field }
      { fieldErrors?.value && <ErrorMessage>{ fieldErrors?.value }</ErrorMessage> }
    </Field>
  )
}
